import { Select } from "../select"

const DEFAULT_PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100];
interface ItensPerPageProps {
    pageSize: number;
    onPageSizeChange: (pageSize: number) => void;
    showPageSizeOptions?: boolean;
    pageSizeOptions?: number[];
    totalItems?: number;
    currentPage: number;
    showTotalItems?: boolean;
}
export const ItensPerPage: React.FC<ItensPerPageProps> = (
    { pageSize = 10,
        onPageSizeChange,
        showPageSizeOptions = true,
        pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
        totalItems,
        currentPage,
        showTotalItems = true,
    }
) => {
    const startItem = totalItems ? (currentPage - 1) * pageSize + 1 : 0;
    const endItem = Math.min(totalItems || 0, currentPage * pageSize);
    if (!showPageSizeOptions) return null;
    return (

        <div className="flex w-full items-center gap-2 text-sm text-white/60">
            <span>Itens por página:</span>

            <Select
                value={pageSize.toString()}
                onChange={(value) => onPageSizeChange?.(Number(value))}
                data={pageSizeOptions.map((size) => ({ value: size.toString(), label: size.toString() }))}
            />

            {totalItems !== undefined && showTotalItems && (
                <span className="ml-2">
                    {startItem}-{endItem} de {totalItems}
                </span>
            )}
        </div>
    )
}

